import { ApiHandlerResult } from '..'
import { Fetcher } from '@/api/fetcher'
import { NEXT_API_URL } from '@/constants'
import type { ShopMegaMenuData } from '@/types/api/shop-mega-menu'
import { BaseApi } from '../base'

// HTTP client for the public shop route handlers. Reached as
// `api.feTofe.shop.*` — the navigation is client-rendered, so it cannot read
// the database directly.
export class ShopApi extends BaseApi {
  constructor(fetcher: Fetcher) {
    super(fetcher)
  }

  async getMegaMenu(): ApiHandlerResult<ShopMegaMenuData> {
    try {
      const res = await this.fetcher.get(NEXT_API_URL.SHOP.MEGA_MENU)
      return await this.parseBodyOrThrow(res)
    } catch (error: any) {
      return [error, null]
    }
  }
}
